import { render, staticRenderFns } from "./Cell.vue?vue&type=template&id=0a7d532f&scoped=true&"
import script from "./Cell.vue?vue&type=script&lang=ts&"
export * from "./Cell.vue?vue&type=script&lang=ts&"
import style0 from "./Cell.vue?vue&type=style&index=0&id=0a7d532f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a7d532f",
  null
  
)

export default component.exports